import { ComponentReport } from './component_report';
import { AccuracyDriversTable } from '../content/accuracy_drivers_table';
import { MarketplaceIdToLabel } from '../const/dropdown_elements';
import { ReportSummary } from './components/report_summary';
import { ColumnSetSelector } from './components/columnset_selector';
import { REPORT_TYPE } from '../../constants/report_type';
import { findColumnSetItems } from './utils/report_preferences';
import { ACCURACY_SUMMARY_REPORTS } from "../../constants/accuracy_summary_reports";
import '../../styles/table.css';

/**
 * A container component that encapsulates the different sections
 * displayed on the component report page.
 */
export class ComponentReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.summaryReportOptions = [ACCURACY_SUMMARY_REPORTS.CP, ACCURACY_SUMMARY_REPORTS.CPLF, ACCURACY_SUMMARY_REPORTS.OP];
    this.state = {
      selectedColumnSetsByUser: null,
      displayAccuracyDrivers: this.props.displayAccuracyDrivers,
      selectedSummaryReport: this.summaryReportOptions[0]
    };

    this.reportData = {};
  }

  componentDidMount() {
    const savedOption = localStorage.getItem('selectedSummaryReport');
    if (savedOption) {
      this.setState({ selectedSummaryReport: savedOption });
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.displayAccuracyDrivers !== this.props.displayAccuracyDrivers) {
      // After a report has been loaded, user may change the report filters selections.
      // If the report already loaded has accuracy drivers section displayed,
      // then it shouldn't become hidden based on the new choices made by the user
      // and vice-versa. So this change of `props.displayAccuracyDrivers` is ignored.
      // The `state.displayAccuracyDrivers` in the constructor copies the initial value of
      // `props.displayAccuracyDrivers` and maintains it.
    }

    if (prevState.selectedSummaryReport !== this.state.selectedSummaryReport) {
      localStorage.setItem('selectedSummaryReport', this.state.selectedSummaryReport);
    }
  };

  updateReportData = (reportData) => {
    this.reportData = reportData;
  };

  updateSelectedSummaryReport = (summaryReport) => {
    this.setState({selectedSummaryReport: summaryReport});
  };

  setColumnSets = (event) => {
    const selectedColumnSetsByUser = event.detail.selectedOptions.map((op) => op.value);
    const selectionChanged = selectedColumnSetsByUser !== this.state.selectedColumnSetsByUser;

    if (selectionChanged) {
      this.setState({ selectedColumnSetsByUser });
      this.props.onSelectedColumnSetsChanged(selectedColumnSetsByUser);
    }
  };

  savePreferences = (selectedColumnSets) => {
    const { columnsJson } = this.props;

    const columnSetItems = findColumnSetItems(columnsJson, selectedColumnSets, REPORT_TYPE.COMPONENT);
    const columns = [...new Set((columnSetItems || []).map((s) => s.columns).flat())];

    this.props.savePreferences(columns, columnSetItems);
  };

  getResponsePayloadsByReportSummary = (responsePayloads) => {
    let cpResponsePayloads = [], cplfResponsePayloads = [], opResponsePayloads = [];

    if (this.props.loading)
      return [cpResponsePayloads, cplfResponsePayloads, opResponsePayloads];

    for (let i = 0; i < responsePayloads.length; i++) {
      const { cpSummaryMap, cplfSummaryMap, opSummaryMap, ...others } = responsePayloads[i];
      cpResponsePayloads.push({ ...others, summaryMap: cpSummaryMap });
      cplfResponsePayloads.push({ ...others, summaryMap: cplfSummaryMap });
      opResponsePayloads.push({ ...others, summaryMap: opSummaryMap });
    }

    return [cpResponsePayloads, cplfResponsePayloads, opResponsePayloads];
  }

  render() {
    const [cpResponsePayloads, cplfResponsePayloads, opResponsePayloads] = this.getResponsePayloadsByReportSummary(this.props.responsePayloads);

    return (
      <div>
        { !this.props.loading && (
          <form id="component-report-selector">
            <div className="select-button-container">
              <input
                type="radio"
                id="cpReport"
                checked={this.state.selectedSummaryReport === this.summaryReportOptions[0]}
                onChange={() => this.updateSelectedSummaryReport(this.summaryReportOptions[0])}
              />
              <label htmlFor="cpReport" className="select-button-label">{this.summaryReportOptions[0]}</label>
            </div>

            <div className="select-button-container">
              <input
                type="radio"
                id="cplfReport"
                checked={this.state.selectedSummaryReport === this.summaryReportOptions[1]}
                onChange={() => this.updateSelectedSummaryReport(this.summaryReportOptions[1])}
              />
              <label htmlFor="cplfReport" className="select-button-label">{this.summaryReportOptions[1]}</label>
            </div>

            <div className="select-button-container">
              <input
                type="radio"
                id="opReport"
                checked={this.state.selectedSummaryReport === this.summaryReportOptions[2]}
                onChange={() => this.updateSelectedSummaryReport(this.summaryReportOptions[2])}
              />
              <label htmlFor="opReport" className="select-button-label">{this.summaryReportOptions[2]}</label>
            </div>
          </form>
        )}

        { this.state.selectedSummaryReport === this.summaryReportOptions[0] && (
          <div>
            <ReportSummary
              loading={this.props.loading}
              headerSuffix={this.summaryReportOptions[0]}
              responsePayloads={cpResponsePayloads}
              reportData={this.reportData}
              summaryMapKeys={this.props.summaryMapKeys}
            />
          </div>
        )}

        { this.state.selectedSummaryReport === this.summaryReportOptions[1] && (
          <div>
            <ReportSummary
                loading={this.props.loading}
                headerSuffix={this.summaryReportOptions[1]}
                responsePayloads={cplfResponsePayloads}
                reportData={this.reportData}
                summaryMapKeys={this.props.summaryMapKeys}
            />
          </div>
        )}

        { this.state.selectedSummaryReport === this.summaryReportOptions[2] && (
          <div>
            <ReportSummary
                loading={this.props.loading}
                headerSuffix={this.summaryReportOptions[2]}
                responsePayloads={opResponsePayloads}
                reportData={this.reportData}
                summaryMapKeys={this.props.summaryMapKeys}
            />
          </div>
        )}

        <div>
          {this.state.displayAccuracyDrivers && (
            <AccuracyDriversTable
              payload={this.props.payload}
              featureList={this.props.featureList}
              marketplaceIdToLabel={MarketplaceIdToLabel}
            />
          )}
        </div>

        <div style={{ marginTop: '1em', marginBottom: '1em' }}>
          <ColumnSetSelector
            placeholder="Benchmark Selection"
            columnSets={this.props.columnsJson.componentSets}
            selectedColumnSets={this.state.selectedColumnSetsByUser || this.props.selectedColumnSets}
            onChange={this.setColumnSets}
          />
        </div>

         <div>
          <ComponentReport
            updateReportData={this.updateReportData}
            selectedColumnSetsByUser={this.state.selectedColumnSetsByUser}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/component_report_container.js